module.exports = __webpack_public_path__ + "img/fenpei1.5af3e720.png";